module.exports = __webpack_public_path__ + "img/sc.01ee2fa2.png";